import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import {
    AuthModule,
    ArrowModule,
    HeaderModule,
    MainMenuModule,
    MainLayoutModule,
    ReleasenotesModule,
    QUANGULAR_CONFIG,
    QuangularConfig,
    AuthRedirectComponent,
    LoaderModule,
} from 'quangular';
import { AppComponent } from './app.component';
import { environment } from '../../src/environments/environment';
import { MsalInterceptor } from '@azure/msal-angular';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StyleClassModule } from 'primeng/styleclass';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SharedModule } from './common/shared.module';
import { ErrorScreenComponent } from './modules/chat/pages/chat/components/error-screen/error-screen.component';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { SettingsModule } from './modules/settings/settings.module';
import { UnauthorizedComponent } from './modules/chat/pages/chat/components/unauthorized/unauthorized.component';
import { ChatModule } from './modules/chat/chat.module';

const menuItems = [
    // { title: 'Chat', link: 'chat', exact: false,  },
    // { title: 'Datasets', link: 'datasets', exact: false },
    // { title: 'Usage Analytics', link: 'admin', exact: false },
];

const config: QuangularConfig = {
    environment: environment,
    appRoles: ['GlobalAdmin', 'User'],
    mainMenu: menuItems,
    roleRoutes: {
        GlobalAdmin: ['chat', 'datasets'],
        User: ['chat', 'datasets'],
    },
    // hideNotificationTray: true,
    // hideUserMenu: false,
    // hideQuantumMenu: false,
    // hideHelpButton: false,

    // profileRoute: "/admin"

};

@NgModule({
    imports: [
        AuthModule.forRoot(config),
        HttpClientModule,
        BrowserModule,
        ArrowModule,
        HeaderModule,
        MainMenuModule,
        MenuModule,
        ButtonModule,
        ChatModule,
        MainLayoutModule,
        BrowserAnimationsModule,
        StyleClassModule,
        LoaderModule,
        ToastModule,
        ConfirmDialogModule,
        SharedModule,
        SettingsModule,
        AppRoutingModule,
        // The order of route configuration is important because the router accepts the first route that matches a navigation request path.
        // ReleasenotesModule should be imported the last one since it includes default('') path resolutions.
        ReleasenotesModule, 
    ],
    providers: [
         {
          provide: HTTP_INTERCEPTORS,
          useClass: MsalInterceptor,
          multi: true
        },
        {
            provide: QUANGULAR_CONFIG,
            useValue: config,
        },
    ],
    exports: [LoaderModule],
    declarations: [AppComponent, ErrorScreenComponent, UnauthorizedComponent],
    bootstrap: [AppComponent, AuthRedirectComponent],
})
export class AppModule {
    // Diagnostic only: inspect router configuration
  constructor(router: Router) {
    // Use a custom replacer to display function names in the route configs
    const replacer = (key, value) => (typeof value === 'function') ? value.name : value;

    console.log('Routes: ', JSON.stringify(router.config, replacer, 2));
  }
}
